import {Col, Row} from "reactstrap";
import React from "react";

interface ModalHeaderProps {
    toggle: () => void
    children: any
}

const ModalHeader = ({toggle, children}: ModalHeaderProps) => {
    return (
        <div className="cottagecentre-modal-header">
            <Row className="align-items-center">
                <Col xs="2">
                    <span className="modal-close-button" onClick={toggle}>X</span>
                </Col>
                <Col xs="10">
                    {children}
                </Col>
            </Row>
        </div>
    )
}

export default ModalHeader;
